module.exports = __webpack_public_path__ + "static/reaktor-josh@2x-2ce2e3b2cb99bfc06707271e63ca2f6f.png";